export default {
    url: '/general',
    template: `
        <courses-courses-edit-occurrence-edit-general
            occurrence="vm.$scope.$parent.vm.occurrence"
            can-manage-occurrences="vm.$scope.$parent.vm.canManageOccurrences"
            course="vm.course"
            sites="vm.sites"
            course-versions="vm.courseVersions"
            direct-managers="vm.directManagers"
        />
    `,
    resolve: {
        sites (SiteResource) {
            return SiteResource.query({ occurrenceOrApgManageSites: true, pageSize: 0 }).$promise;
        },
        courseVersions (CourseVersionResource, course) {
            return CourseVersionResource.query({ courseId: course.id, pageSize: 0 }).$promise;
        },
        directManagers (UserManagerService, ROLE_PRIVILEGE_ENUM) {
            return UserManagerService.queryDirectManagersByPrivileges(
                [
                    ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE,
                    ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE,
                    ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE
                ],
                {
                    expand: 'sites,userAssignments',
                    excludeInActiveUsers: true
                }
            );
        }
    },
    controller ($scope, course, sites, courseVersions, directManagers) {
        this.$scope = $scope;
        $scope.$parent.vm.step = 1;
        this.course = course;
        this.sites = sites;
        this.courseVersions = courseVersions;
        this.directManagers = directManagers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/edit/general/index.js